import { Divider } from "@ps-design-system/components/Divider";
import { Skeleton } from "@ps-design-system/components/Skeleton";

const ActivateListingsPageSkeleton = () => {
  return (
    <div className="ps-container-lg-margin ps-container-fixed tw-py-64">
      <div className="ps-row">
        <div className="col-xs-12 space-y-8">
          <div className="tw-max-w-[680px]">
            <Skeleton height={40} width="90%" />
            <Skeleton height={45} width="100%" classNames="tw-mt-8" />
            <Skeleton height={45} width="80%" classNames="tw-mt-8" />
          </div>

          <div className="tw-flex tw-gap-16 tw-mt-32">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={index}
                height={225}
                width="100%"
                classNames="tw-rounded-lg"
              />
            ))}
          </div>

          <Divider />

          <div className="tw-flex tw-items-center tw-justify-between">
            <Skeleton height={40} width={68} />
            <Skeleton height={40} width={135} />
          </div>
        </div>
      </div>
    </div>
  );
};

export { ActivateListingsPageSkeleton };
